import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectFullName = (store: StoreSchema) => store.users.filters.fullName
export const selectFullNameQuery = (store: StoreSchema) => store.users.queryFilters.fullName